import { Component } from '@angular/core';
import { AppComponent } from '../app.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataserviceService } from '../dataservice.service';

@Component({
  selector: 'app-training',
  templateUrl: './training.component.html',
  styleUrl: './training.component.css'
})
export class TrainingComponent {
  expandSet = new Set<number>();
  currentUser: any;
  isModalVisible: boolean = false;
  isLoading: boolean = false;
  trainingForm: FormGroup
  trainingList: any = [];
  quizzes: any = [];
  loading: boolean = false;

  folders: any = [];
  panels: any = [];

  constructor(
    private app: AppComponent,
    private data: DataserviceService) {

      this.trainingForm = new FormGroup({
        type: new FormControl(null, [Validators.required]),
        id: new FormControl(null),
        name: new FormControl(null, [Validators.required]),
        link: new FormControl(null),
        quiz: new FormControl(null),
        folder: new FormControl(null)
      });

    }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);
    console.log(this.currentUser)
    this.getFolders();
  }


  getFolders() {
    this.loading = true;
    this.data.getData(`training/folders`)
      .subscribe({
        next: (res: any) => {
          this.folders = res;
          this.getTraining();
        }
      })
  }

  getTraining() {
    this.loading = true;
    this.data.getData('training/training-list')
      .subscribe({
        next: (res: any) => {

          this.trainingList = res?.data

          this.folders = this.folders.map((folder: any) => ({
            ...folder,
            training: this.trainingList.filter((t: any) => t.folder_id === folder.id),
            expand: false
          }));


          this.panels = this.folders.map((folder: any) => ({
            name: folder.name,
            active: folder.expand, 
            disabled: false,
            training: folder.training,
            crm_id: folder.crm_id, 
            folder_id: folder.id 
          }));


          this.loading = false
        }
      })
  }

  onTypeChange(value: string): void {

    if(value == 'file') {
      this.trainingForm.get('folder')?.setValidators(Validators.required);
      this.trainingForm.get('link')?.setValidators(Validators.required);
    }else {
      this.trainingForm.get('folder')?.setValidators(null);
      this.trainingForm.get('link')?.setValidators(null);
    }


    this.trainingForm.updateValueAndValidity();
  }

  hasPermissions(permission: string): boolean {
    return this.app.hasPermission(permission)
  }
  

  showModal(t: any) {
    if(t) {

      this.trainingForm.patchValue({
        'type': 'file',
        'id': t.id,
        'name': t.name,
        'quiz': t.quiz_id,
        'link': t.link
      })

    }

    this.isModalVisible = true;
  }

  async handleOk() {

    if(this.trainingForm.valid) {
      this.isLoading = true;
      if(this.trainingForm.get('id')?.value) {
        await this.updateTraining();
      }else {

        if(this.trainingForm.get('type')?.value == 'file') {
          await this.createTraining();
        }else {
          await this.createTrainingFolder();
        }
      }
    }
  }

  async createTrainingFolder() {
    let obj = {
      name: this.trainingForm.get('name')?.value
    }

    this.data.postData(obj, 'training/new-folder')
      .subscribe({
        next: (res: any) => {
          this.getFolders();
          this.handleCancel();
          this.isLoading = false;
        },
        error: (err: any) => {
          console.log('ERR: ', err)
        }
      })
  }

  async createTraining() {
    let obj = {
      name: this.trainingForm.get('name')?.value,
      link: this.trainingForm.get('link')?.value,
      user_id: this.currentUser?.id,
      quiz: this.trainingForm.get('quiz')?.value,
      folder_id: this.trainingForm.get('folder')?.value
    }

    this.data.postData(obj, 'training/upload')
      .subscribe({
        next: (res: any) => {
          this.getFolders();
          this.handleCancel();
          this.isLoading = false;
        },
        error: (err: any) => {
          console.log('ERR: ', err)
        }
      })
  }

  updateTraining() {
    let obj = {
      id: this.trainingForm.get('id')?.value,
      name: this.trainingForm.get('name')?.value,
      link: this.trainingForm.get('link')?.value,
      quiz: this.trainingForm.get('quiz')?.value
    }

    this.data.postData(obj, 'training/update')
    .subscribe({
      next: (res: any) => {
        this.getFolders();
        this.handleCancel();
        this.isLoading = false;
      },
      error: (err: any) => {
        console.log('ERR: ', err)
      }
    })
  }

  handleCancel() {
    this.isModalVisible = false;
    this.trainingForm.reset();
  }

  onExpandChange(folder: any) {
    this.folders[this.folders.indexOf(folder)].expand = !this.folders[this.folders.indexOf(folder)].expand 
  }

}
